// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import system from './system_store'

const rootReducer = {
  auth,
  navbar,
  layout,
  system
}

export default rootReducer
